import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "content"]

  connect() {
    if (this.hasSelectTarget) {
      this.toggle()
    }
  }

  toggle() {
    if (!this.hasSelectTarget) return

    const selectedValue = this.selectTarget.value

    this.contentTargets.forEach(content => {
      const contentValue = content.dataset.conditionalSelectValue

      if (selectedValue === contentValue) {
        content.classList.remove("d-none")
      } else {
        content.classList.add("d-none")
      }
    })
  }
}
